// Single source of truth for tracking couriers (/kurir/<value>) and their display
// labels. Labels feed the indexed /kurir/* page titles via getCourierSeo(), so
// change them deliberately. Kept tiny and separate from courierData.js (which
// carries long blurbs) so the homepage bundle stays small.
export const COURIERS = [
  { value: "borzo", label: "Borzo" },
  { value: "jne", label: "JNE" },
  { value: "pos", label: "POS Indonesia" },
  { value: "jnt", label: "J&T Express" },
  { value: "jnt_cargo", label: "J&T Cargo" },
  { value: "sicepat", label: "SiCepat" },
  { value: "tiki", label: "Tiki" },
  { value: "anteraja", label: "AnterAja" },
  { value: "dash_express", label: "Dash Express" },
  { value: "deliveree", label: "Deliveree" },
  { value: "gojek", label: "Gojek" },
  { value: "grab", label: "Grab Express" },
  { value: "wahana", label: "Wahana Express" },
  { value: "ninja", label: "Ninja Xpress" },
  { value: "jdl", label: "JDL Express" },
  { value: "lalamove", label: "Lalamove" },
  { value: "paxel", label: "Paxel" },
  { value: "lion", label: "Lion Parcel" },
  { value: "pcp", label: "PCP Express" },
  { value: "jet", label: "JET Express" },
  { value: "rex", label: "REX Express" },
  { value: "first", label: "First Logistics" },
  { value: "ide", label: "ID Express" },
  { value: "spx", label: "SPX (Shopee Express)" },
  { value: "kgx", label: "KGXpress" },
  { value: "sap", label: "SAP Express" },
  { value: "sentralcargo", label: "Sentral Cargo" },
  { value: "jxe", label: "JX Express" },
  { value: "rpx", label: "RPX Express" },
  { value: "lex", label: "Lazada Express" },
  { value: "indah_cargo", label: "Indah Cargo" },
  { value: "dakota", label: "Dakota Cargo" },
  { value: "rara", label: "Rara" },
  { value: "gtl", label: "GTL (GoTo Logistics)" },
  { value: "ant_cargo", label: "Ant Cargo" },
  { value: "next_logistik", label: "Next Logistics" },
  { value: "laris_cargo", label: "Laris Cargo" },
  { value: "kurir_tokopedia", label: "Kurir Rekomendasi (Tokopedia)" }
];

export const COURIER_LABELS = Object.fromEntries(COURIERS.map(({ value, label }) => [value, label]));

// Stable alphabetical order by slug for footers, lists, and the sitemap.
export const COURIERS_BY_SLUG = [...COURIERS].sort((a, b) => a.value.localeCompare(b.value));
